import React from 'react';
import { Box, Divider, Link, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BoletiaLogo } from './BoletiaLogo';
import Image from './Image';
import { BoletiaBackgroundFooter } from './BoletiaBackgroundFooter';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import dayjs from 'dayjs';

const YEAR = dayjs().year();

function BoletiaFooter() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { termsAndConditions, shoppingTerms, noticeOfPrivacy, help } =
    useAnalyticsEvents();

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '141px',
          backgroundImage: `url(${BoletiaBackgroundFooter})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <Stack
          sx={{ width: '100%', height: '100%', color: theme.palette.grey[0] }}
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
        >
          <Stack
            sx={{ width: '70%' }}
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            spacing={0}
          >
            <Stack alignItems="center">
              <Image
                sx={{
                  width: '42px',
                  height: '42px',
                }}
                src={BoletiaLogo}
              />
            </Stack>
            <Stack alignItems="center">
              <Link
                href="https://boletia.com/terms-of-service"
                variant="subtitle2"
                sx={{ color: theme.palette.grey[0] }}
                marginX={0.5}
                onClick={() => {
                  termsAndConditions();
                }}
                target="_blank"
                rel="noopener"
              >
                {t('checkout.global.terms')}
              </Link>
            </Stack>
            <Stack alignItems="center">
              <Divider
                sx={{
                  width: '1px',
                  height: '25px',
                  background: theme.palette.grey[0],
                }}
              />
            </Stack>
            <Stack alignItems="center">
              <Link
                href="https://boletia.com/terms-of-purchase"
                variant="subtitle2"
                sx={{ color: theme.palette.grey[0] }}
                marginX={0.5}
                onClick={() => {
                  shoppingTerms();
                }}
                target="_blank"
                rel="noopener"
              >
                {t('checkout.global.termsPurchase')}
              </Link>
            </Stack>
            <Stack alignItems="center">
              <Divider
                sx={{
                  width: '1px',
                  height: '25px',
                  background: theme.palette.grey[0],
                }}
              />
            </Stack>
            <Stack alignItems="center">
              <Link
                href="https://boletia.com/aviso-de-privacidad"
                variant="subtitle2"
                sx={{ color: theme.palette.grey[0] }}
                marginX={0.5}
                onClick={() => {
                  noticeOfPrivacy();
                }}
                target="_blank"
                rel="noopener"
              >
                {t('checkout.global.privacyNotice')}
              </Link>
            </Stack>
            <Stack alignItems="center">
              <Divider
                sx={{
                  width: '1px',
                  height: '25px',
                  background: theme.palette.grey[0],
                }}
              />
            </Stack>
            <Stack alignItems="center">
              <Link
                href="https://help.boletia.com/hc/es-419/categories/12339457958541-Soy-asistente-de-un-evento-"
                variant="subtitle2"
                sx={{ color: theme.palette.grey[0] }}
                marginX={0.5}
                onClick={() => {
                  help();
                }}
                target="_blank"
                rel="noopener"
              >
                {t('checkout.global.needHelp')}
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '98px',
          backgroundColor: (theme) => theme.palette.grey[900],
        }}
      >
        <Stack
          sx={{ width: '100%', height: '100%' }}
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <Stack alignItems="center">
            <Typography variant="subtitle2" sx={{ color: '#FFFFFF' }}>
              {t('checkout.global.madeIn', { year: YEAR })}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}

export default BoletiaFooter;
